import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import { reducer as formReducer } from "redux-form";
import languageReducer from "MODULES/App/reducers/Language";


const appReducer = combineReducers({
  routing: routerReducer,
  form: formReducer,
  LanguageReducer: languageReducer,
});

export const rootReducer = (state, action) => {
  if (action.type === "log_out") {
    state = undefined;
  }
  return appReducer(state, action);
};



// WEBPACK FOOTER //
// ./src/redux/rootreducer.js